var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.maintenanceNotification)?_c('div',{class:`alert notification-${_setup.maintenanceNotification.type}`,attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-text",domProps:{"innerHTML":_vm._s(_setup.maintenanceNotification.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }